import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ToasterMessageService } from "../../../services/toaster-message.service";
import { ContextService } from '@apply4u/services/context-service';
import { DefaultPageNumber, DefaultPageSize } from '@apply4u/shared/constant/constant';
import { IsNotNull } from '@apply4u/shared/helpers/common/type-safe-helpers';

@Component({
  selector: 'smart-pagination',
  templateUrl: './smart-pagination.component.html',
  styleUrls: ['./smart-pagination.component.css']
})
export class SmartPaginationComponent implements OnInit, OnChanges {
  @Input() PageSize: number = DefaultPageSize;
  @Input() PageNumber: number = DefaultPageNumber;
  @Input() TotalRecords: number = 0;
  @Input() IsDefaultTopScroll: boolean = true;
  @Output() PageNumberChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() PageSizeChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() AllRecordsDisplayed: EventEmitter<void> = new EventEmitter<void>();

  TotalPages: number = 0;
  TotalPagesArray: number[] = [];
  CalculatedPages: number = 0;
  ContextService: ContextService;
  isAllRecordsChecked: boolean = false;

  constructor(private contextService: ContextService,
    private toasterServiceService: ToasterMessageService) {
      this.ContextService = this.contextService;
      
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (IsNotNull(changes["TotalRecords"])) {
      this.InitializePagination();
    }
  }

  InitializePagination() {
    if (this.TotalRecords > 0) {
      this.TotalPages = Math.trunc((this.TotalRecords + (this.PageSize - 1)) / this.PageSize);
      this.CalculateNavigationPages();
      this.checkAllRecordsDisplayed();
    }
  }
  checkAllRecordsDisplayed(): void {
    if (this.PageNumber === this.TotalPages && !this.isAllRecordsChecked) {
      this.AllRecordsDisplayed.emit(); 
    }
  }

  ScrollTop(): void {
    if (this.contextService.IsBrowser) {
      window.scroll({
        top: 280,
        behavior: 'smooth',
      });
    }
  }

  CalculateNavigationPages(): void {
    this.TotalPagesArray = [];

    if (this.PageNumber > 0 && this.TotalPages > 0 && this.PageNumber <= this.TotalPages) {
      this.CalculatedPages = this.PageNumber <= 4 ? 5 : this.PageNumber + 2;

      while (this.CalculatedPages >= 0 && this.CalculatedPages > this.TotalPages) {
        this.CalculatedPages -= 1;
      }

      for (let i = this.CalculatedPages; i >= 1 && i > (this.CalculatedPages - 5) && i <= this.TotalPages; i--) {
        this.TotalPagesArray.unshift(i);
      }
    }
  }

  NextPreviousResultPage(IsNextClick: boolean): void {
    if (IsNextClick && this.PageNumber <= this.TotalPages) {
      this.OnChangePageNumber(this.PageNumber + 1);
      this.CalculateNavigationPages();
    }
    else if (IsNextClick == false && this.PageNumber > 1) {
      this.OnChangePageNumber(this.PageNumber - 1);
      this.CalculateNavigationPages();
    }
    this.checkAllRecordsDisplayed();
  }

  OnChangePageNumber(pageNumber: number): void {
    if (pageNumber > 0 && pageNumber <= this.TotalPages) {
      this.PageNumber = pageNumber;
      this.PageNumberChanged.emit(this.PageNumber);
      if (this.IsDefaultTopScroll == true) {
        this.ScrollTop();
      }
    } else {
      this.toasterServiceService.Error("No results for this page.", null);
    }
  }

  OnPageSizeChange(): void {
    this.InitializePagination();
    this.PageSizeChanged.emit(this.PageSize);
  }
}
